import { render } from "./HeroiconsSolidPaperClip.vue?vue&type=template&id=3f2a303c"
const script = {}

import exportComponent from "/Users/mior/Projects/laravel/nova/silver-surfer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPaperClip.vue"]])

export default __exports__